import React from 'react';
export function AdditionalLinksSection() {
  return <div className="bg-gray-50 p-8 rounded-xl border border-gray-200 text-center space-y-6" data-id="element-3402">
      <p className="text-lg text-gray-700 font-bold" data-id="element-3403">
        Additional product information linked below:
      </p>
      <div className="space-y-4" data-id="element-3404">
        <a href="/BodorLaserCutting.html" className="block text-2xl font-bold text-orange hover:text-navy hover:underline transition-colors" data-id="element-3405">
          Bodor High Power Fiber Laser Cutting Machines
        </a>
        <div className="flex flex-wrap justify-center gap-6 text-lg font-bold" data-id="element-3406">
          <a href="/BodorLaserCutting.html#Bodor_high_power_laser_cutting_machines" className="text-[#0c79c8] hover:underline" data-id="element-3407">
            High Power
          </a>
          <a href="/BodorLaserCutting.html#high_precision_laser_cutting_machines" className="text-[#0c79c8] hover:underline" data-id="element-3408">
            High Precision
          </a>
          <a href="/BodorLaserCutting.html#Laser_Tube_Cutting_Machines" className="text-[#0c79c8] hover:underline" data-id="element-3409">
            Laser Tube Cutter
          </a>
        </div>
      </div>
    </div>;
}